import { create } from "zustand";
import { AssociatedPartyAPI } from "../api";
import { AssociatedPartiesItem } from "../api/transformers/associatedParty";
import restUtils from "core/utils/rest";

type AssociatedPartyStore = {
  data: AssociatedPartiesItem[];
  loading: boolean;
  error: unknown;
  fetchData: (personId: string) => Promise<void>;
};

const useAssociatedPartyStore = create<AssociatedPartyStore>((set) => ({
  data: [],
  loading: true,
  error: null,
  // actions
  fetchData: async (personId) => {
    set({ loading: true, error: null, data: [] });
    try {
      const result = await AssociatedPartyAPI.getAssociatedParties(personId, true);
      set({ data: result, loading: false });
    } catch (err) {
      console.error(err);
      set({ error: err, loading: false });
    }
  },
}));

export default useAssociatedPartyStore;

interface AssociatedPartyRow {
  roleType: string;
  roleTypeDesc: string;
  roleSqe: string | number;
  personId: string;
  title: string;
  firstName: string;
  middleName: string;
  surname: string;
  entityType: string;
  entityName: string;
  amlStatus: string;
  idAndV: string;
  pepStatus: string;
  sanctionsStatus: string;
  riskStatus: string;
  updatedDate?: string;
  createdDate?: string;
  updatedTime?: string;
  createdTime?: string;
}

interface AssociatedPartiesResponse {
  rows: AssociatedPartyRow[];
}

export function fetchAssociatedParties(personId: string): Promise<Array<ReturnType<typeof dataToModel>>> {
  return restUtils.call(
    "PortalApi",
    `hubwise-api/aml/investors/${personId}/associated-parties?includeAmlResults=true`,
    "GET"
  ).then((response) => {
    const r = response as AssociatedPartiesResponse;
    return r.rows.map(dataToModel);
  });
}

function dataToModel(row: AssociatedPartyRow) {
  return {
    role: row.roleType,
    roleDesc: row.roleTypeDesc,
    // sqe is an API typo
    roleSeq: Number(row.roleSqe),
    investorId: row.personId,
    title: row.title,
    firstName: row.firstName,
    middleName: row.middleName,
    surname: row.surname,
    entityType: row.entityType,
    entityName: row.entityName,
    amlStatus: row.amlStatus,
    idAndV: row.idAndV,
    pepStatus: row.pepStatus,
    sanctionsStatus: row.sanctionsStatus,
    riskRatingStatus: row.riskStatus,
    createdDate: row.updatedDate || row.createdDate,
    createdTime: row.updatedTime || row.createdTime
  };
}
